var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiPoutingFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 40.0002C11.018 40.0002 0.248779 33.7391 0.248779 20.0002C0.248779 6.26142 11.018 0.000244141 21.0001 0.000244141C26.5457 0.000244141 31.662 1.82493 35.4545 5.1523C39.569 8.80167 41.7515 13.9537 41.7515 20.0002C41.7515 26.0468 39.569 31.163 35.4545 34.8124C31.662 38.1398 26.51 40.0002 21.0001 40.0002Z",
    fill: "url(#paint0_radial_390_2420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1343 8.11157C40.0413 11.1885 41.0359 14.8522 41.0359 18.9273C41.0359 24.9738 38.8534 30.0901 34.7389 33.7395C30.9464 37.0669 25.7944 38.9273 20.2846 38.9273C13.823 38.9273 7.04663 36.2976 3.04663 30.7198C6.89636 37.0382 14.1379 40.0007 21.0001 40.0007C26.51 40.0007 31.662 38.1402 35.4545 34.8128C39.569 31.1635 41.7515 26.0472 41.7515 20.0007C41.7515 15.4425 40.51 11.3924 38.1343 8.11157Z",
    fill: "#D84213"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2773 34.3959C28.1556 34.3494 28.0447 34.2743 27.9589 34.1741C24.4776 30.5569 18.7209 30.446 15.1038 33.9272C15.0215 34.0095 14.9356 34.0918 14.8569 34.1741C14.771 34.2743 14.6601 34.3494 14.5385 34.3959C14.2701 34.4961 13.966 34.4389 13.7513 34.2492C13.5403 34.0632 13.4687 33.7662 13.576 33.5051C14.6422 30.768 17.8122 28.6213 21.4079 28.6213C25.0036 28.6213 28.1735 30.768 29.2397 33.5015C29.347 33.7627 29.2755 34.0596 29.0644 34.2457C28.8497 34.4353 28.5456 34.4925 28.2773 34.3959Z",
    fill: "#422B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0468 22.1177C18.2453 21.1088 14.943 19.1696 13.7516 18.6043C13.308 18.4004 12.8464 18.2358 12.3741 18.1141C12.2883 18.0891 12.1953 18.0784 12.1058 18.0784C11.63 18.0891 11.2221 18.429 11.1255 18.8977C11.0146 19.3843 11.265 19.8852 11.723 20.0855C12.2847 20.361 13.265 20.8834 14.2811 21.4594C13.4332 21.9639 12.9144 22.8798 12.9144 23.8673V24.3896C12.9144 25.8709 14.1165 27.073 15.5978 27.073C17.079 27.073 18.2811 25.8709 18.2811 24.3896V23.8673C18.2811 23.8458 18.2811 23.8279 18.2811 23.8065C18.6639 23.7814 19.0074 23.5524 19.1756 23.209C19.3509 22.8512 19.3008 22.4254 19.0468 22.1177Z",
    fill: "#422B0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.705 18.8983C31.6048 18.4261 31.1898 18.0898 30.7068 18.0862C30.6173 18.0862 30.5243 18.0969 30.4384 18.122C29.9662 18.24 29.5046 18.4046 29.061 18.605C27.8696 19.1631 24.5672 21.1094 23.7658 22.1112C23.5118 22.4225 23.4688 22.8518 23.6477 23.2096C23.8195 23.5567 24.1594 23.7821 24.5458 23.8071V23.8679V24.3903C24.5458 25.8715 25.7479 27.0737 27.2291 27.0737C28.7103 27.0737 29.9125 25.8715 29.9125 24.3903V23.8679C29.9125 22.884 29.3937 21.9717 28.5493 21.4672C29.5654 20.8912 30.5458 20.3688 31.1075 20.0933C31.569 19.893 31.823 19.3885 31.705 18.8983Z",
    fill: "#422B0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4618 21.9853C14.9538 21.742 14.3419 21.9567 14.0951 22.4647C13.9055 22.8618 13.9913 23.3377 14.3097 23.6454C14.8178 23.8887 15.4296 23.674 15.6765 23.166C15.8661 22.7688 15.7802 22.293 15.4618 21.9853Z",
    fill: "#896024"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0931 21.9853C26.5851 21.742 25.9733 21.9567 25.7264 22.4647C25.5368 22.8618 25.6227 23.3377 25.9411 23.6454C26.4491 23.8887 27.061 23.674 27.3078 23.166C27.4974 22.7688 27.4116 22.293 27.0931 21.9853Z",
    fill: "#896024"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_390_2420",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0001 20.0002) scale(20.3791 20.3791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FAC742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBBA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FBA931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FC9224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FE7413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiPoutingFace);
export default __webpack_public_path__ + "static/media/emoji-pouting-face.2b362dc221cbe6b38ae631360774553c.svg";
export { ForwardRef as ReactComponent };